import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetGroupActivities(id: string | undefined) {
  return useQuery(queries.userGroups.getGroupActivitiesById(id || ''))
}
